<template>
  <Section
    v-bind="$attrs"
    :title="title"
    :shouldShowSearch="shouldShowSearch"
    :toolbarActions="toolbarActions"
    @onClicked="(val) => $emit(val)"
    icon="construction"
    :breadCrumbs="breadCrumbs"
    @onClickBreadcrumb="(val) => $emit('onClickBreadcrumb', val)"
    :isLoading="isLoading"
  >
    <template v-slot:toolbarExtension>
      <v-layout row wrap justify-space-between subheading>
        <v-flex shrink>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>info</v-icon>
                  {{
                    _entityPropertyValueByName({
                      entityList: assetStatusList,
                      idKey: "id",
                      idValue: assetDetail.statusId,
                      propertyKey: "name",
                    })
                  }}
                </span>
              </template>
              <span>Equipment Status</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>event</v-icon>
                  {{
                    _entityPropertyValueByName({
                      entityList: activityTypeList,
                      idKey: "id",
                      idValue: assetDetail.activityTypeIdLast,
                      propertyKey: "name",
                    })
                  }}
                </span>
              </template>
              <span>Last Activity Performed</span>
            </v-tooltip>
          </div>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>style</v-icon>
                  {{
                    _entityPropertyValueByName({
                      entityList: modelList,
                      idKey: "id",
                      idValue: assetDetail.modelId,
                      propertyKey: "name",
                    })
                  }}
                </span>
              </template>
              <span>Model</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>store</v-icon>
                  {{
                    _manufacturerByModelId({
                      modelList: modelList,
                      manufacturerList: manufacturerList,
                      modelId: assetDetail.modelId,
                    }).name || "[UNKNOWN]"
                  }}
                </span>
              </template>
              <span>Manufacturer</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>category</v-icon>
                  {{
                    _categoryByModelId({
                      modelList: modelList,
                      categoryList: categoryList,
                      modelId: assetDetail.modelId,
                    }).name || "[UNKNOWN]"
                  }}
                </span>
              </template>
              <span>Category</span>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex shrink text-xs-left text-sm-right>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>supervised_user_circle</v-icon>
                  {{
                    _entityPropertyValueByName({
                      entityList: clientList,
                      idKey: "id",
                      idValue: assetDetail.clientId,
                      propertyKey: "name",
                    })
                  }}
                </span>
              </template>
              <span>Client</span>
            </v-tooltip>
          </div>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>place</v-icon>
                  {{
                    _entityPropertyValueByName({
                      entityList: locationList,
                      idKey: "id",
                      idValue: assetDetail.locationId,
                      propertyKey: "name",
                    })
                  }}
                </span>
              </template>
              <span>Location</span>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex xs12 v-if="assetDetail.comments">
          <v-icon>comment</v-icon>
          {{ assetDetail.comments }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import mixinAssetHelper from '../../../../common/mixins/mixinAssetHelper'

import Section from '../../../../common/components/layouts/Section'
import SectionContainerPage from '../../../../common/components/layouts/SectionContainerPage'

export default {
  inheritAttrs: false,
  components: {
    Section,
    SectionContainerPage,
  },
  mixins: [mixinAssetHelper],
  props: {
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    breadCrumbs: Array,
    title: String,
    shouldShowSearch: {
      type: Boolean,
    },
    assetDetail: {
      type: Object,
      required: true,
    },
    modelList: {
      type: Array,
      required: true,
    },
    manufacturerList: {
      type: Array,
      required: true,
    },
    categoryList: {
      type: Array,
      required: true,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    assetStatusList: {
      type: Array,
      required: true,
    },
    locationList: {
      type: Array,
      required: true,
    },
    clientList: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({}),
  computed: {},
  methods: {},
}
</script>
